import { useContext } from "react";
import { EcsMetaContext } from "../context/EcsMetaContext";
/**
 * Provides access to metadata like baseUrl
 * - requires {@link ConfigurationController}
 * @category Hook
 * @export
 * @returns {ConfigurationMeta}
 */
export function useConfigurationMeta() {
    return useContext(EcsMetaContext);
}
//# sourceMappingURL=useConfigurationMeta.js.map